import {
  ReplyForwardEditorAction,
  ReplyForwardEmailPreview,
} from '../../../type';

export const getDefaultValueForToField = (
  action: ReplyForwardEditorAction,
  selectedEmail: ReplyForwardEmailPreview,
) => {
  if (action === 'reply' || action === 'replyAll') {
    if (selectedEmail.toProspectId) {
      return selectedEmail.to || [];
    }
    if (selectedEmail.fromProspectId) {
      return [selectedEmail.fromEmail];
    }
  }
  return [];
};
